export const OpenInAppCard = () => {
  return null;
};
